import { lazy } from 'react';

import { ComputeCenterOverview } from '@/components-biz/ComputeCenterOverview';
import i18n from '@/i18n';
import AppLayout from '@/layout/AppLayout';
import LeftNavLayout from '@/layout/LeftNavLayout';
import { Overview } from '@/pages/tenant/overview';
import { lazyNamedImport } from '@/utils/lazyNamedImport';

import ErrorBoundary from '../ErrorBoundary';
import { joinPrefix, mergeRouters } from '../util';
import {
  aiCenter,
  alertCenter,
  apiKeyManagement,
  appCenter,
  artifactCenter,
  auditLog,
  clusterAsset,
  costCenter as commonCostCenter,
  instanceManagement,
  intelligentStorage,
  logCenter,
  monitorCenter,
  networkSecurity,
  operationOverview,
} from './dcSharedWs';
import { SUB_CENTER, createSubCenterRoutes } from './subCenterRoutes';

const TenantMembers = lazy(() => import('@/pages/tenant/security-center/members'));
const TenantRoles = lazy(() => import('@/pages/tenant/security-center/roles'));
// const Overview = lazyNamedImport(() => import('@/pages/tenant/overview'), 'Overview');
const Recharge = lazyNamedImport(() => import('@/pages/tenant/cost-center/recharge'), 'Recharge');
const BenefitsCenterPage = lazyNamedImport(() => import('@/pages/tenant/cost-center/benefits-center'), 'BenefitsCenterPage');
const TenantSetting = lazy(() => import('@/pages/tenant/setting'));
const t = i18n.t.bind(i18n);

// 总揽
const overview = [
  {
    path: '/overview',
    element: <ComputeCenterOverview scope="tenant" />,
  },
];
const chargeOverview = [{ path: '/overview', element: <Overview /> }];

// 费用中心
const costCenter = [
  ...commonCostCenter,
  {
    title: t('common:recharge.records'),
    path: '/recharge',
    element: <Recharge />,
  },
  {
    title: 'benefitsCenter',
    path: '/benefits-center',
    element: <BenefitsCenterPage />,
  },
];
// 租户安全中心
const securityCenter = [
  {
    title: 'members',
    path: '/members',
    element: <TenantMembers />,
  },
  {
    title: 'roles',
    path: '/roles',
    element: <TenantRoles />,
  },
  ...auditLog,
];
// 租户设置
const setting = [
  {
    title: 'tenant-setting',
    path: '/setting',
    element: <TenantSetting />,
  },
];

const pathPrefixes = ['/console/:tenant/cluster/:cluster'];
const leafRoutes = mergeRouters([
  overview,
  artifactCenter,
  networkSecurity,
  intelligentStorage,
  instanceManagement,
  clusterAsset,
  costCenter,
  securityCenter,
  setting,
]);
const subCenterRoutes = [
  ...createSubCenterRoutes([chargeOverview, costCenter, securityCenter, setting], SUB_CENTER.CHARGE, ['console']),
  // 安全中心 / 租户设置挂到各子中心下，保证 fixBottom 非外链跳转不丢失子中心上下文
  ...createSubCenterRoutes([operationOverview, monitorCenter, logCenter, alertCenter, securityCenter, setting], SUB_CENTER.OPS, [
    'console',
  ]),
  ...createSubCenterRoutes([aiCenter, securityCenter, setting], SUB_CENTER.AI, ['console']),
  ...createSubCenterRoutes([appCenter, apiKeyManagement, securityCenter, setting], SUB_CENTER.APP, ['console']),
];
export const tenantRouters = {
  path: '/',
  element: <AppLayout />,
  title: t('auth-conf:get.kvm.console'),
  children: [
    {
      element: <LeftNavLayout />,
      errorElement: <ErrorBoundary />,
      children: [...joinPrefix(leafRoutes, pathPrefixes), ...subCenterRoutes],
    },
  ],
};
